import { render, staticRenderFns } from "./RasmusUserDetail.vue?vue&type=template&id=37635c88&"
import script from "./RasmusUserDetail.vue?vue&type=script&lang=ts&"
export * from "./RasmusUserDetail.vue?vue&type=script&lang=ts&"
import style0 from "./RasmusUserDetail.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports